import { useTranslation } from "react-i18next";

import { FormikProps, FormikValues } from "formik";

import { FieldPath } from "../../../../../../formik/FormikField.types";
import { IOptionItem } from "../../../../../../formik/formik-autocomplete/FormikAutocomplete.types";
import { FormikAutocompleteSelect } from "../../../../../../formik/formik-autocomplete/FormikAutocompleteSelect";
import { relationshipLabelKey } from "../../../../utils/relationshipLabels.utils";
import { RELATIONSHIP_OPTIONS } from "../../RelativesView.types";

interface Props<T extends FormikValues> {
  formik: FormikProps<T>;
  path: FieldPath<T>;
  label: string;
}

export function RelationshipSelect<T extends FormikValues>({ formik, path, label }: Props<T>) {
  const { t } = useTranslation();

  const options: IOptionItem[] = RELATIONSHIP_OPTIONS.map((option) => ({
    id: option,
    label: t(relationshipLabelKey(option)),
  }));

  return <FormikAutocompleteSelect formik={formik} path={path} options={options} label={label} />;
}
